module.exports = __webpack_public_path__ + "098a624c76128060d1d6e9fe64cf966e.svg";